import React, { useEffect, useRef } from "react";
import { Navigate, Route, Routes, useLocation, useNavigate } from "react-router-dom";
import App from "../App";
import Home from "../Components/Home";
import { Dashboard } from "../Components/DashBoard";
import { LandingPage } from "../Components/LandingPage";
import { baseData, qcData } from "../Services/Constants";
import AllJob from "../Components/AllJob";
import UnAuthorizedUser from "../Components/UnAuthorizedUser";
import AccessRequired from "../Components/AccessRequired";
import DispatchedJobScreen from "../Components/DispatchedJobScreen";
import Report from "../Components/Report";
import ChecklistErrorLog from "../Components/ChecklistErrorLog";
import CsrReport from "../Components/CsrReport";
import DeletionReport from "../Components/DeletionReport";
import TimeoutError from "../Components/timeOutError";
import QuoteCompare from "../Components/QuoteCompare/QuoteCompare";
import QCDataRenderer from "../Components/QuoteCompare/QCDataRenderer";
import Discrepancy from "../Components/Discrepancy";
import GetAllQCJobs from "../Components/QuoteCompare/GetAllQCJobs";
import AmsAction from "../Components/ReviwerActionInCsrSheet/AmsAction";
import CsrQuoteCompareWrapper from "../Components/CsrQuoteCompareWrapper";
import StaticPage from "../Components/StaticComponent.js/StaticPage";
import GetAllProposalQCJobs from "../Components/ProposalBuilder/GetAllProposalQCJobs"
import ProposalBuilderCommonComponent from "../Components/ProposalBuilder/PropsalBuilderCommonComponent";
import QuoteAdminAccess from "../Components/QuoteAdminAccess";
import QuoteDeletionReport from "../Components/QuoteCompare/QuoteDeletionReport"
import ProposalClientSync from "../Components/ProposalClientSync";


const AppRoutes = ({ selectedOption }) => {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (location.pathname === "/qcJob") {
      let url = new URL(window.location.href);
      let jobId = url?.searchParams.get("jobId") || url?.searchParams.get("jobid");
      let urlParamToken = url?.searchParams.get("token");

      if (!jobId || !urlParamToken) {
        navigate("/qcAllJobs");
        return;
      }

      try {
        const decodedToken = atob(urlParamToken || "");
        if (jobId !== decodedToken) {
          navigate("/qcAllJobs");
        }
      } catch (err) {
        navigate("/qcAllJobs");
      }
    }
  }, []);

  return (
    <>
      <Routes>
        {selectedOption === "PolicyCheck" ? <Route path="/" element={<Navigate to="/job" />} /> : <Route path="/" element={<Navigate to="/quoteCompare" />} />}
        <Route path="/UnAuthorizedUser" element={<UnAuthorizedUser />} />
        <Route path="/Warning" element={<StaticPage />} />
        <Route path="/DispatchedJob" element={<DispatchedJobScreen />} />
        <Route path="/AccessDenied" element={<AccessRequired />} />
        <Route path="/xlpage" element={<App baseData={baseData} />} />
        <Route path="/csrView" element={<App baseData={baseData} />} />
        <Route path="/csrQuoteCompare" element={<CsrQuoteCompareWrapper />} />

        <Route path="/qcJob" element={<QCDataRenderer />} />
        <Route path="/createproposalbuilder" element={<GetAllProposalQCJobs />} />
        <Route path="/proposalsections" element={<ProposalBuilderCommonComponent />} />
        {selectedOption === "QuoteCompare" && (
          <>
            <Route path="/quoteCompare" element={<QuoteCompare />} />
            <Route path="/qcAllJobs" element={<GetAllQCJobs />} />
            <Route path="/QuoteAdminAccess" element={<QuoteAdminAccess />} />
            <Route path="/checkListError" element={<ChecklistErrorLog />} />
            <Route path="/ProposalSync" element={<ProposalClientSync />} />
            {/* <Route path="/proposalBuilder" element={<GetAllProposalQCJobs/>}/> */}
            {sessionStorage.getItem("role") &&
              sessionStorage.getItem("role").includes("DeletionReport") && (
                <Route path="/QuoteDeletionReport" element={<QuoteDeletionReport />} />
              )}
            {/* <Route path="/createproposalbuilder" element={<ProposalBuilderCommonComponent />}/> */}
          </>
        )}

        {selectedOption === "PolicyCheck" && (
          <>
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/job" element={<Home />} />
            <Route path="/AllJob" element={<AllJob />} />
            <Route path="/AmsAction" element={<AmsAction />} />
            <Route path="/checkListError" element={<ChecklistErrorLog />} />

            {/* Role-based routes for "PolicyCheck" */}
            <Route path="/AdminAccess" element={<Report />} />

            {sessionStorage.getItem("roles") &&
              sessionStorage.getItem("roles").includes("CsrReport") && (
                <Route path="/CSRReportPanel" element={<CsrReport />} />
              )}
            {sessionStorage.getItem("roles") &&
              (
                <Route path="/Discrepancy" element={<Discrepancy />} />
              )}
            {sessionStorage.getItem("role") &&
              sessionStorage.getItem("role").includes("DeletionReport") && (
                <Route path="/DeletionReportPanel" element={<DeletionReport />} />
              )}
          </>
        )}
      </Routes>
    </>
  );
};

export default AppRoutes;
